module.exports = __webpack_public_path__ + "static/media/Screenshot 2026-03-13 at 04.32.45.5d7fc6e7.png";